"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Checkbox_1 = require("./Checkbox");
exports.default = Checkbox_1.default;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/duc/components/atoms/Checkbox/index.js
// module id = 652
// module chunks = 8